import { render } from "./SelectCustomerPage.vue?vue&type=template&id=aef04b96&scoped=true"
import script from "./SelectCustomerPage.vue?vue&type=script&lang=js"
export * from "./SelectCustomerPage.vue?vue&type=script&lang=js"

import "./SelectCustomerPage.vue?vue&type=style&index=0&id=aef04b96&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aef04b96"]])

export default __exports__